import styled, {keyframes} from 'styled-components';
import {dFlex, justifyCenter} from '../../../../globalVariables/GlobalFlex';

export const wrap = styled.div<{$initial?: boolean}>`
    ${dFlex};
    ${justifyCenter};
    flex: none;
    padding: ${({$initial}) => ($initial ? 'var(--space-xl) var(--space-lg)' : 'var(--space-sm) 0')};
`;

const spin = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

export const spinner = styled.span`
    display: inline-block;
    width: 28px;
    height: 28px;
    border: 3px solid var(--color-border-subtle);
    border-top-color: var(--color-brand-main);
    border-radius: var(--border-radius-border-radius-full);
    animation: ${spin} 0.7s linear infinite;
`;
